export const REDUCER_NAME = "blogslice";

export default interface iBlogState {
  data: any[]; // 🔥 THIS WAS MISSING
  isLoading: boolean;
  error: any;
} 

